<mat-sidenav-container class="sidebar-container">
  <mat-sidenav #appDrawer mode="side" [opened]="mobileQuery.matches">
    <header>
      <nav>
        <button mat-icon-button fxHide fxShow.lt-md="true">
          <mat-icon class="menu-icon" (click)="toggleSidenav()">close</mat-icon>
        </button>
        <img
          src="{{ logo }}"
          fxShow.lt-md="false"
          class="container__title__logo"
        />
        <img
          src="{{ logoA }}"
          fxHide
          fxShow.lt-md="true"
          class="container__title__logo__a"
        />
        <!-- <button mat-icon-button [matMenuTriggerFor]="accountMenu">
          <mat-icon class="menu-icon">more_vert</mat-icon>
        </button> -->
      </nav>
      <div fxHide fxShow.lt-md="true">
        <mat-icon class="menu-icon">account_circle</mat-icon>
        <span> {{ userLogged.name }}</span>
      </div>
    </header>
    <mat-nav-list>
      <app-nav-menu-list-item
        class="nav-menu-list-item"
        *ngFor="let item of navItems"
        [item]="item"
      >
      </app-nav-menu-list-item>
    </mat-nav-list>
    <mat-divider></mat-divider>
    <mat-nav-list>
      <!--   <button mat-menu-item (click)="about()">
        <mat-icon>help</mat-icon>
        <span>Sobre</span>
      </button> -->

      <button mat-menu-item (click)="logout()">
        <mat-icon>power_settings_new</mat-icon>
        <span>Sair</span>
      </button>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header></app-header>
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </mat-sidenav-content>
</mat-sidenav-container>
